import React from "react";

const News = () => {
  return (
    <section>News</section>
  );
};

export default News;